module.exports = __webpack_public_path__ + "media/images/favicons/favicon-96x96-cc50c328e3fabffc21013088d87c9879.png";